import { render, staticRenderFns } from "./SecurityReport.vue?vue&type=template&id=16b7a316"
import script from "./SecurityReport.vue?vue&type=script&lang=js"
export * from "./SecurityReport.vue?vue&type=script&lang=js"
import style0 from "./SecurityReport.vue?vue&type=style&index=0&id=16b7a316&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports